
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as admin0eiku7Jj1aMeta } from "/app/pages/admin.vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as errorcxo3GvC8JMMeta } from "/app/pages/error.vue?macro=true";
import { default as healthV1WC4tFWSoMeta } from "/app/pages/health.vue?macro=true";
import { default as history2LdGTesqcBMeta } from "/app/pages/history.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as internalUser7qbCXw41EFMeta } from "/app/pages/internalUser.vue?macro=true";
import { default as myPageGgmCveymZsMeta } from "/app/pages/myPage.vue?macro=true";
import { default as _91id_93m5hwe6XdulMeta } from "/app/pages/orders/[id].vue?macro=true";
import { default as deliveriesNIJbUr8Ms5Meta } from "/app/pages/orders/deliveries.vue?macro=true";
import { default as indexG1Ehu1sqkUMeta } from "/app/pages/orders/index.vue?macro=true";
import { default as orderTransmissionForm4ZsarVEgg0Meta } from "/app/pages/orderTransmissionForm.vue?macro=true";
import { default as orderTransmissionListjI4yZgm25yMeta } from "/app/pages/orderTransmissionList.vue?macro=true";
import { default as qrCodeValidationG3mWOKu8qgMeta } from "/app/pages/qrCodeValidation.vue?macro=true";
import { default as xl_45floristD5V79xrys0Meta } from "/app/pages/xl-florist.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorcxo3GvC8JMMeta || {},
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "health",
    path: "/health",
    meta: healthV1WC4tFWSoMeta || {},
    component: () => import("/app/pages/health.vue")
  },
  {
    name: "history",
    path: "/history",
    component: () => import("/app/pages/history.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "internalUser",
    path: "/internalUser",
    component: () => import("/app/pages/internalUser.vue")
  },
  {
    name: "myPage",
    path: "/myPage",
    component: () => import("/app/pages/myPage.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/app/pages/orders/[id].vue")
  },
  {
    name: deliveriesNIJbUr8Ms5Meta?.name ?? "orders-deliveries",
    path: "/orders/deliveries",
    meta: deliveriesNIJbUr8Ms5Meta || {},
    component: () => import("/app/pages/orders/deliveries.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/app/pages/orders/index.vue")
  },
  {
    name: "orderTransmissionForm",
    path: "/orderTransmissionForm",
    component: () => import("/app/pages/orderTransmissionForm.vue")
  },
  {
    name: "orderTransmissionList",
    path: "/orderTransmissionList",
    component: () => import("/app/pages/orderTransmissionList.vue")
  },
  {
    name: "qrCodeValidation",
    path: "/qrCodeValidation",
    component: () => import("/app/pages/qrCodeValidation.vue")
  },
  {
    name: "xl-florist",
    path: "/xl-florist",
    meta: xl_45floristD5V79xrys0Meta || {},
    component: () => import("/app/pages/xl-florist.vue")
  }
]